import {toast} from 'react-toastify';
import Notification from "../features/Components/Notification/Notification";

export const notifyError = (errorSnackText) =>
  toast.error(errorSnackText, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
  });

export const notifySuccess = (successSnackText) =>
  toast.success(successSnackText, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined
  });


export const notifyPush = (notification) => {
    const toastId = toast.info(
        <Notification notification={notification} push={true} onClose={() => toast.dismiss(toastId)} />,
        {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            closeButton: false,
        }
    );
    return toastId;
};